<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('forms.inputs.load') + ' ' + ((this.$route.params.code == undefined) ? '' : this.$route.params.code)">
          <form @submit.prevent>
            <div class="row">
              <div class="flex xs6 sm3">
                <va-input
                  :label="$t('forms.inputs.codLoad')"
                  v-model="loadParams.code"
                  value="loadParams.code"
                />
              </div>
              <div class="flex xs6 sm3">
                <va-date-picker
                  :label="$t('forms.dateTimePicker.deliveryDate')"
                  :config="{dateFormat: 'd/m/Y'}"
                  v-model="loadParams.deliveryDate"
                />
              </div>
              <div class="flex xs6 sm3">
                <va-input
                  :label="$t('forms.inputs.loadIntegrationId')"
                  v-model="loadParams.tripNumber"
                  value="loadParams.tripNumber"
                />
              </div>
            </div>

            <div class="row">
              <div class="flex xs6 sm3">
                <va-select
                  :label="$t('forms.selects.loadTypes')"
                  v-model="loadParams.loadType"
                  keyBy="id"
                  textBy="name"
                  :options="loadTypes"
                  searchable
                />
              </div>
              <div class="flex xs6 sm3">
                <va-date-picker
                  :label="$t('forms.dateTimePicker.start_of_operation')"
                  :config="{dateFormat: 'd/m/Y'}"
                  v-model="loadParams.start_of_operation"
                />
              </div>
              <div class="flex xs6 sm3">
                <va-select
                  v-model="loadParams.operation_name"
                  :options='daily_operations'
                  :label="$t('forms.selects.operation')"
                  textBy="operation_name"
                  keyBy="id"
                  clearable="false"
                  placeholder="Selecione a operação desejada"
                />
              </div>
            </div>

            <div class="row">
              <div class="flex xs6 sm3">
                <va-input
                  v-model="search_vehicle"
                  :label="$t('forms.inputs.search_vehicle')"
                />
              </div>
              <div class="flex sm1">
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-search"
                  class="mr-1"
                  @click="getFilteredVehicles(search_vehicle)"
                />
                <va-button
                  small
                  color="secondary"
                  icon="fa fa-close"
                  class="mr-1"
                  @click="resetlabel()"
                />
              </div>

              <div class="flex xs6 sm4">
                <va-select
                  :label="$t('forms.selects.vehicle')"
                  v-model="loadParams.vehicle"
                  keyBy="id"
                  textBy="vehicle_fullname"
                  :options="vehicles"
                  searchable
                />
              </div>
            </div>

            <div class="row">
              <div class="flex md2 sm6 xs12">
                <va-button
                  v-if="loadParams.loadId == ''"
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="create(loadParams)"
                >
                  {{ $t('menu.save') }}
                </va-button>
                <va-button
                  v-else
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="ma-0"
                  @click="update(loadParams)"
                >
                  {{ $t('menu.update') }}
                </va-button>
              </div>
              <div class="flex md2 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'loads', params: {
                    current_page: this.$route.params.current_page,
                    search: this.$route.params.search,
                    delivery_date: this.$route.params.delivery_date,
                    perPage: this.$route.params.perPage }
                  }"
                >
                  {{ $t('menu.back') }}
                </va-button>
              </div>

              <div class="flex md2 sm6 xs12">
                <va-button
                  v-if="loadStatus === 'Paletização'"
                  medium
                  inline
                  color="dark"
                  icon="fa fa-list-alt"
                  class="ma-0"
                  :to="{ name: 'form-load-products', params: {
                    loadId: this.$route.params.id,
                    code: this.$route.params.code
                  }}"
                >
                  {{ $t('menu.products') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import LoadAPI from '@/services/LoadAPI'
import LoadTypeAPI from '@/services/LoadTypeAPI'
import VehicleAPI from '@/services/VehicleAPI'
import DailyOperationAPI from '@/services/DailyOperationAPI'
import { showError } from '@/global'
import { mapState } from 'vuex'

export default {
  name: 'form-loads',
  components: {},
  data () {
    return {
      loadParams: {
        loadId: '',
        code: '',
        locality: '',
        deliveryDate: '',
        vehicle: {
          id: '',
          name: '',
          vehicle_fullname: '',
        },
        name: '',
        daily_operation_id: '',
        operation_name: '',
        start_of_operation: '',
        localityId: '',
        tripNumber: '',
        loadType: {
          id: '',
          name: '',
        },
      },
      search_vehicle: '',
      vehicles: [],
      localities: [],
      loadSteps: [],
      drivers: [],
      vehicleName: '',
      loadStatus: '',
      loadIntegrationId: '',
      date: '',
      daily_operations: [],
      loadTypes: [],
    }
  },
  computed: {
    ...mapState(['currentUser', 'currentLocality']),
  },
  mounted () {
    this.readItems()
  },
  methods: {
    async readItems () {
      this.current_page = this.$route.params.current_page

      await LoadTypeAPI.getAllLoadTypes().then(response => {
        this.loadTypes = response.data.load_types
      })

      if (this.$route.params.id !== undefined) {
        await LoadAPI.getLoadById(this.$route.params.id).then(response => {
          let res = response.data.load

          this.loadParams.loadId = res.id
          this.loadParams.code = res.code
          this.loadParams.deliveryDate = res.delivery_date
          this.loadParams.locality = res.locality
          this.loadParams.vehicle = res.vehicle_fullname
          this.loadParams.localityId = res.locality_id
          this.loadParams.start_of_operation = res.start_of_operation
          this.loadParams.operation_name = res.operation_name
          this.loadParams.daily_operation_id = res.daily_operation_id
          this.loadParams.tripNumber = res.trip_number
          this.loadParams.loadIntegrationId = res.load_integration_id
          this.loadParams.loadType = res.load_type
          this.loadStatus = res.status
          this.loadTypeId = res.load_type_id
        })
      }

      this.date = this.loadParams.start_of_operation
      this.loadParams.localityId = this.currentLocality.id
    },

    getFilteredVehicles (searchVehicle) {
      const vehicleParams = {
        search_params: searchVehicle,
        quantity: 10000,
      }
      VehicleAPI.getFilteredVehicles(vehicleParams).then(response => {
        this.vehicles = response.data.vehicles
      })
    },

    resetlabel () {
      this.loadParams.vehicle = { id: '', name: '', vehicle_fullname: '' }
      this.search_vehicle = ''
      this.vehicles = []
    },

    create (loadParams) {
      LoadAPI.createLoad(loadParams).then(response => {
        this.data = response.data
        this.loadParams.loadId = response.data.load.id

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push({ name: 'form-load-products',
          params: {
            loadId: loadParams.loadId,
            code: loadParams.code,
          },
        })
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    update (loadParams) {
      LoadAPI.updateLoad(loadParams).then(response => {
        this.data = response.data

        this.showToast(response.data.message, {
          icon: 'fa-thumbs-o-up',
          position: 'top-right',
          duration: 5000,
        })

        this.$router.push('/admin/tables/loads')
      }).catch(e => {
        this.showToast(e.response.data.error, {
          icon: 'fa-thumbs-o-down',
          position: 'top-right',
          duration: 5000,
        })
      })
    },

    async getDailyOperations (date, locality) {
      this.loading = true
      DailyOperationAPI.getDailyOperations(date, locality).then(response => {
        this.daily_operations = response.data.daily_operations

        if (this.daily_operations.length > 0) {
          this.loadParams.operation_name = this.daily_operations
        } else {
          this.date = []
          this.loadParams.operation_name = ''
        }
        this.loading = false
      }).catch(e => { showError(e); this.loading = false })
    },
  },
  watch: {
    'loadParams.locality': function (newLocality, oldLocality) {
      if (this.loadParams.start_of_operation !== '' && newLocality.id !== undefined) {
        this.getDailyOperations(this.loadParams.start_of_operation, newLocality.id)
      }
    },

    'loadParams.start_of_operation': function (newDate, oldDate) {
      if (this.loadParams.locality.id !== undefined) {
        this.getDailyOperations(newDate, this.loadParams.locality.id)
      } else if (this.loadParams.locality_id !== '' && oldDate !== '') {
        this.getDailyOperations(newDate, this.loadParams.locality_id)
      }
    },

    '$store.state.currentLocality': function () {
      this.getDailyOperations(this.date, this.loadParams.locality_id)
    },
  },
}
</script>
